import { render, staticRenderFns } from "./InitCompanyWizard.vue?vue&type=template&id=bb9018d6&scoped=true"
import script from "./InitCompanyWizard.vue?vue&type=script&lang=js"
export * from "./InitCompanyWizard.vue?vue&type=script&lang=js"
import style0 from "./InitCompanyWizard.vue?vue&type=style&index=0&id=bb9018d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9018d6",
  null
  
)

export default component.exports